import React from 'react';
import ReactDOM from 'react-dom/client';
import { LiminalThemeProvider } from '@liminal/web-ui/theme/LiminalThemeProvider';
import { liminalTheme } from './theme/theme';
import { ADMIN_ENV, type AdminEnv } from './lib/env';
import App from './App';
import './styles/globals.css';

// One console per environment, one tab each: the title is how they are told
// apart in a tab strip.
const DOCUMENT_TITLE: Record<AdminEnv, string> = {
  dev: 'Liminal Admin (dev)',
  testnet: 'Liminal Admin (testnet)',
  prod: 'Liminal Admin',
};
document.title = DOCUMENT_TITLE[ADMIN_ENV];

const root = document.getElementById('root');
if (!root) {
  throw new Error('index.html has no #root element to render into');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <LiminalThemeProvider baseline="global" theme={liminalTheme}>
      <App />
    </LiminalThemeProvider>
  </React.StrictMode>
);
